<template>
  <section
    class="main landing-page-content"
    :style="getGradient"
  >
    <sign-in-button class="signin-button" />
    <div class="center-bkgrnd" />
    <landing-hero-banner
      v-if="isCompanyActive"
      class="hero-banner landing-page d-flex"
      :servicer="servicer"
      :loading="loadingFetchServicerData"
    >
      <servicer-wrapper
        :servicer="servicerProfile"
        :partner="partnerProfile"
      />
    </landing-hero-banner>
    <disabled-company-banner
      v-if="!isCompanyActive"
      class="hero-banner landing-page d-flex"
      :servicer="servicer"
      :loading="loadingFetchServicerData"
    >
      <servicer-wrapper
        :servicer="servicerProfile"
        :partner="partnerProfile"
      />
    </disabled-company-banner>
    <go-mobile-wrapper
      v-if="$vuetify.breakpoint.lgAndUp && showMobileContent && isCompanyActive"
      class="go-mobile-wrapper d-flex"
      :servicer="servicerProfile"
    />
    <div
      v-if="!showMobileContent || $vuetify.breakpoint.mdAndDown"
      class="mobile-underlay"
    />
    <footer-wrapper
      v-if="isCompanyActive"
      :dark-theme="true"
      :servicer="servicerProfile"
      :sac="sac"
    />
  </section>
</template>

<script>
import SignInButton from './Header/SignInButton.vue'
import LandingHeroBanner from './HeroBanner/LandingHeroBanner.vue'
import DisabledCompanyBanner from './HeroBanner/DisabledCompanyBanner.vue'
import ServicerWrapper from './Servicer/ServicerWrapper.vue'
import GoMobileWrapper from './GoMobile/GoMobileWrapper.vue'
import FooterWrapper from './Footer/FooterWrapper.vue'

import { NullServicer, NullPartner } from './Servicer/nullProfile'
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import shareBySmsMixin from '../../common/shareBySmsMixin'
import brandThemeMixin from '~/components/common/brandThemeMixin'
import fetchServicerMixin from '../Onboarding/Shared/fetchServicerMixin.js'

export default {
  name: 'LandingPage',
  components: {
    SignInButton,
    LandingHeroBanner,
    DisabledCompanyBanner,
    ServicerWrapper,
    GoMobileWrapper,
    FooterWrapper
  },
  mixins: [shareBySmsMixin, brandThemeMixin, fetchServicerMixin],
  data () {
    return {
      partner: new NullPartner(),
      servicer: new NullServicer()
    }
  },
  computed: {
    servicerProfile () {
      return this.servicer
    },
    isCompanyActive () {
      return this.publicData?.servicer_profile?.is_company_active
    },
    partnerProfile () {
      return this.partner
    },
    themeColor () {
      return this.$vuetify.theme.themes.light.primary
    },
    profileColorLight () {
      return rgbaFromHexAndOpacity(this.themeColor, 0.5)
    },
    profileColorDark () {
      return rgbaFromHexAndOpacity(this.themeColor, 1.0)
    },
    sac () {
      return this.$route.params.code
    },
    getGradient () {
      return `background: linear-gradient(90deg, ${this.profileColorDark} 0.68%, ${this.profileColorLight} 51.8%, ${this.profileColorDark} 100%);`
    },
    showMobileContent () {
      return this.servicer.borrower_web_content_setting_show_mobile_content_on_landing_page && this.servicerProfile.parentOrganization?.organization_setting_twilio_sms_enabled
    }
  },
  beforeCreate () {
    // used by brandThemeMixin to fetch custom themes
    this.$store.activationCode = this.$route.params.code
  },
  methods: {
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import "~/assets/css/snui";

  .signin-button {
    position: absolute;
    top: 32px;
    right: 32px;
  }
  .main {
    height: 100%;
    padding-top: 360px;
  }
  .center-bkgrnd {
    position: absolute;
    bottom: 0;
    background: $sn-gray-01;
    height: calc(100% - 360px);
    width: 100%;
  }
  .hero-banner {
    position: relative;
    margin-top: -200px;
    max-width: 1184px;
  }
  .go-mobile-wrapper {
    margin-top: 76px;
    margin-bottom: -45px;
    max-width: 1184px;
  }
  .watermark {
    position: relative;
    margin-bottom: 8px;
    padding-bottom: 30px;
    background-color: $sn-white;
  }

  .landing-page-content {
    height: 100%;
    flex-direction: column;
    display: flex;
  }
  .landing-page {
    display: flex;
  }
  .mobile-underlay {
    display: block;
    position: relative;
    bottom: 0;
    flex: 1;
    width: 100vw;
    height: 105px;
    background-color: $sn-gray-01;
  }

  @media screen and (max-width: 990px) {
    .mobile-underlay {
      background-color: $sn-white;
    }
  }

  @media screen and (min-width: 991px) and (max-width: 1184px) {
    .hero-banner {
      max-width: 950px;
    }
  }

  @media screen and (max-width: $medium-screen-size) {
    .watermark {
      background-color: initial;
    }
  }
</style>
